// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { xHeaderHandlerType } from "@steiner/App/Handlers/XNG/Header";
import { Draft } from "immer";
import { RefObject } from "react";

export type xHeaderStateType = Readonly<{
    isSticky?: boolean;
    registerMenu: string[];
    unregisterMenu: string;
    showGlobalMessage?: boolean;
    zipCodeAddress?: { zipCode: string; country: string };
    headerHeight: string;
    stickyHeaderHeight?: number;
}>;

export const initialXHeaderState: xHeaderStateType = {
    isSticky: false,
    registerMenu: [],
    unregisterMenu: "",
    headerHeight: "0",
    stickyHeaderHeight: 0,
    showGlobalMessage: true,
};

const xHeaderReducer = {
    "xHeader/update": (draft: Draft<xHeaderStateType>, action: { data: xHeaderHandlerType }) => {
        const { key, value } = action.data;
        if (key === "registerMenu") {
            draft.registerMenu?.push(value as string);
        } else if (key === "unregisterMenu") {
            draft.registerMenu = (draft.registerMenu || []).filter(item => value !== item);
        } else {
            draft[key] = value as never;
        }
    },
};

const xHeader = createTypedReducerWithImmer(initialXHeaderState, xHeaderReducer);

(reducers as any).xHeader = xHeader;

export type xHeaderState = {
    xHeader: xHeaderStateType;
} & ApplicationState;

type xHeaderReducers = {
    [key: string]: typeof xHeader;
};

export type xHeaderActions = Parameters<xHeaderReducers[keyof xHeaderReducers]>[1];
